/*import LocomotiveScroll from "locomotive-scroll";
import { laptop } from "@app/breakpoints.js";

export default class Scroll {
  constructor() {
    this.scrollItems = [];
    this.directionChangeCallbacks = [];
    this.positionChangeCallbacks = [];
    this.scrollItemsInView = [];
    this.scrollContainer = document.querySelector("[data-scroll-container]");
    this.direction = this.scrollContainer.dataset.direction
      ? this.scrollContainer.dataset.direction
      : "vertical";

    this.scroll = new LocomotiveScroll({
      el: document.querySelector("[data-scroll-container]"),
      smooth: true,
      direction: this.direction,
      getDirection: true,
      getSpeed: true,
      tablet: { smooth: false, direction: "vertical" },
      smartphone: { smooth: false, direction: "vertical" },
    });

    this.scroll.on("scroll", this.onScroll);
  }

  scrollTo = (target, options = {}) => {
    this.scroll.scrollTo(target, options);
  };

  update = () => {
    this.scroll.update();
  };

  onCall = (scrollID, way, object) => {
    this.scrollItemsInView.forEach((item) => {
      if (item.scrollID === scrollID) {
        item.callback(scrollID, way, object);
      }
    });
  };

  onScroll = (args) => {
    this.positionChangeCallbacks.forEach((callback) => {
      callback(args);
    });

    if (
      args.direction &&
      !this.stopped &&
      (args.direction !== this.direction || !this.direction)
    ) {
      this.direction = args.direction;

      this.directionChangeCallbacks.forEach((callback) => {
        callback(this.direction);
      });
    }

    this.scrollItems.forEach((item) => {
      if (typeof args.currentElements[item.scrollID] === "object") {
        item.callback(args.currentElements[item.scrollID], args.scroll);
      }
    });
  };

  register = (scrollID, callback) => {
    this.scrollItems.push({
      scrollID: scrollID,
      callback: callback,
    });
  };

  registerOnInViewTrigger = (scrollID, callback) => {
    this.scrollItemsInView.push({
      scrollID: scrollID,
      callback: callback,
    });
  };

  registerOnScrollPositionChange = (callback) => {
    this.positionChangeCallbacks.push(callback);
  };

  registerOnScrollDirectionChange = (callback) => {
    this.directionChangeCallbacks.push(callback);
  };

  stop = () => {
    this.stopped = true;
    this.scroll.stop();
  };

  start = () => {
    this.stopped = false;
    this.scroll.start();
  };

  onComplete = () => {
    this.scroll.on("call", this.onCall);
  };
}
*/

import Lenis from "@studio-freight/lenis";
import { getRaf } from "@app";
import { laptop } from "@app/breakpoints";

export default class Scroll {
  constructor() {
    this.positionChangeCallbacks = [];
    this.x = window.scrollX;
  }

  initScroll = () => {
    this.raf?.unregister("scroll");

    if (this.lenis) {
      this.lenis.destroy();
    }

    this.lenis = new Lenis({
      orientation: this.orientation,
      gestureOrientation: "both",
    });
    this.lenis.setScroll(this.x, 0);

    this.raf?.register("scroll", this.render);

    this.lenis.on("scroll", this.onScroll);
  };

  registerOnScrollPositionChange = (callback) => {
    this.positionChangeCallbacks.push(callback);
  };

  scrollTo = (target, options = {}) => {
    this.lenis.scrollTo(target, options);
  };

  render = (timestamp) => {
    this.lenis.raf(timestamp);
  };

  onScroll = (event) => {
    const {
      velocity,
      animatedScroll,
      direction,
      dimensions: { scrollWidth, width },
    } = event;
    const progress = animatedScroll / (scrollWidth - width);

    this.positionChangeCallbacks.forEach((callback) => {
      callback({
        velocity,
        x: animatedScroll,
        progress,
        direction,
      });
    });
  };

  onReady = () => {
    this.raf = getRaf();
    this.orientation = undefined;
    this.onResize();
  };

  onResize = () => {
    this.windowSize = {
      width: window.innerWidth,
      height: window.innerHeight,
    };

    const orientation =
      this.windowSize.width < laptop ? "vertical" : "horizontal";
    if (orientation !== this.orientation) {
      this.orientation = orientation;
      this.initScroll();
    }
  };
}
